//
//
//
//
//
//
//
//

export default {
  name: 'common_wrapper',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  computed: {
    wrapperStyle: function wrapperStyle() {
      var config = this.config || {};
      var bottomBgColor = this.bottomBgColor || (config.bottomBgColor && config.bottomBgColor.color ? config.bottomBgColor.color[0].item : '');
      return {
        background: bottomBgColor,
        overflow: 'hidden' // Create BFC to contain margins of the inner box
      };
    },
    boxStyle: function boxStyle() {
      var config = this.config || {};
      var marginConfig = this.marginConfig || config.marginConfig || {
        val: 0,
        valList: [{
          val: 0
        }, {
          val: 0
        }, {
          val: 0
        }, {
          val: 0
        }]
      };
      var paddingConfig = this.paddingConfig || config.paddingConfig || {
        val: 0,
        valList: [{
          val: 0
        }, {
          val: 0
        }, {
          val: 0
        }, {
          val: 0
        }]
      };
      // bottomBgColor logic moved to wrapperStyle
      var componentBgConfig = this.componentBgConfig || config.componentBgConfig;
      var zIndexConfig = this.zIndexConfig || config.zIndexConfig;
      var borderConfig = this.borderConfig || config.borderConfig;
      var shadowConfig = this.shadowConfig || config.shadowConfig;
      var fillet = this.fillet || config.fillet;
      var borderRadius = this.borderRadius || (config.borderRadius ? config.borderRadius : '0');
      var style = {
        marginTop: (!marginConfig.isAll ? marginConfig.val : marginConfig.valList[0].val) + 'px',
        marginBottom: (!marginConfig.isAll ? marginConfig.val : marginConfig.valList[2].val) + 'px',
        marginLeft: (!marginConfig.isAll ? marginConfig.val : marginConfig.valList[3].val) + 'px',
        marginRight: (!marginConfig.isAll ? marginConfig.val : marginConfig.valList[1].val) + 'px',
        paddingTop: (!paddingConfig.isAll ? paddingConfig.val : paddingConfig.valList[0].val) + 'px',
        paddingBottom: (!paddingConfig.isAll ? paddingConfig.val : paddingConfig.valList[2].val) + 'px',
        paddingLeft: (!paddingConfig.isAll ? paddingConfig.val : paddingConfig.valList[3].val) + 'px',
        paddingRight: (!paddingConfig.isAll ? paddingConfig.val : paddingConfig.valList[1].val) + 'px',
        overflow: 'hidden'
      };

      // Background
      if (componentBgConfig) {
        if (componentBgConfig.tabVal === 0) {
          var colorConfig = componentBgConfig.colorConfig;
          var colorDirection = componentBgConfig.colorDirection;
          if (colorConfig && colorConfig.color) {
            var colors = colorConfig.color.map(function (c) {
              return c.item;
            });
            if (colors.length > 1) {
              var deg = '90deg';
              if (colorDirection) {
                switch (colorDirection.tabVal) {
                  case 0:
                    deg = '90deg';
                    break;
                  case 1:
                    deg = '180deg';
                    break;
                  case 2:
                    deg = '135deg';
                    break;
                  case 3:
                    deg = '200deg';
                    break;
                }
              }
              style.background = "linear-gradient(".concat(deg, ", ").concat(colors[0], " 0%, ").concat(colors[1], " 100%)");
            } else {
              style.background = colors[0];
            }
          }
        } else if (componentBgConfig.tabVal === 1) {
          var imageConfig = componentBgConfig.imageConfig;
          if (imageConfig && imageConfig.url) {
            style.backgroundImage = "url(".concat(imageConfig.url, ")");
            style.backgroundRepeat = 'no-repeat';
            style.backgroundSize = 'cover';
            style.backgroundPosition = 'center';
          }
        }
      }
      // Removed else if (bottomBgColor) fallback as it is now on the wrapper

      // Border Radius
      if (fillet) {
        if (fillet.type) {
          // 4 corners
          var valList = fillet.valList;
          style.borderRadius = "".concat(valList[0].val, "px ").concat(valList[1].val, "px ").concat(valList[3].val, "px ").concat(valList[2].val, "px");
        } else {
          // Single value
          style.borderRadius = fillet.val + 'px';
        }
      } else if (borderRadius && borderRadius !== '0') {
        style.borderRadius = borderRadius;
      }

      // Border
      if (borderConfig && borderConfig.tabVal) {
        // Assuming tabVal 1 means show
        var color = borderConfig.colorConfig ? borderConfig.colorConfig.color[0].item : '#000';
        var width = borderConfig.widthConfig ? borderConfig.widthConfig.val : 1;
        var borderStyle = 'solid';
        if (borderConfig.styleConfig) {
          var styleVal = borderConfig.styleConfig.tabVal;
          if (styleVal === 1) {
            borderStyle = 'dashed';
          } else if (styleVal === 2) {
            borderStyle = 'dotted';
          }
        }
        style.border = "".concat(width, "px ").concat(borderStyle, " ").concat(color);
      }

      // Shadow
      if (shadowConfig && shadowConfig.tabVal) {
        var x = shadowConfig.xConfig ? shadowConfig.xConfig.val : 0;
        var y = shadowConfig.yConfig ? shadowConfig.yConfig.val : 0;
        var blur = shadowConfig.blurConfig ? shadowConfig.blurConfig.val : 0;
        var spread = shadowConfig.spreadConfig ? shadowConfig.spreadConfig.val : 0;
        var _color = shadowConfig.colorConfig ? shadowConfig.colorConfig.color[0].item : '#000';
        style.boxShadow = "".concat(x, "px ").concat(y, "px ").concat(blur, "px ").concat(spread, "px ").concat(_color);
      }

      // Z-Index
      if (zIndexConfig) {
        style.zIndex = zIndexConfig.val;
        style.position = 'relative'; // z-index needs position
      }

      // Text Color
      if (this.textColor && this.textColor.color) {
        style.color = this.textColor.color[0].item;
      }
      return style;
    }
  }
};